<template>
  <div style="margin-left:-15px">
    <div class="row mb-3">
      <div class="col-sm-6">
        <b-form-group label="Status" label-cols="3">
          <b-form-select v-model="filter.status" @change="updateList()" :options="statusOptions"></b-form-select>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <div class="text-sm-right">
          <button type="button" class="btn btn-primary btn-sm btn-rounded mr-2" @click="openSettingsModal()">
            <i class="mdi mdi-cog"></i> Configurações
          </button>
          <button type="button" class="btn btn-success btn-sm btn-rounded" @click="updateList()">
            <i class="mdi mdi-reload"></i> Atualizar
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center" v-show="publicQuestions.length === 0">
        <h5 class="text-truncate font-size-14 p-4 mt-4">Ainda não há perguntas públicas. </h5>
        <i class="bx bx-tired bx-lg"></i>
      </div>

      <div class="table-responsive mt-3 mb-0" v-show="publicQuestions.length > 0">
        <table class="table table-centered table-nowrap table-hover">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Pergunta</th>
              <th>Votos</th>
              <th>Status</th>
              <th>Data</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(question, i) in publicQuestions" :key="i">
              <td>{{ question.user.data.name }}</td>
              <td :title="question.question">{{ question.question.length > 50 ? question.question.substring(0, 50) + '...' : question.question }}</td>
              <td><b-badge variant="primary">{{ question.votes_count }}</b-badge></td>
              <td>
                <b-dropdown
                  size="sm"
                  :variant="getStatusVariant(question.status)"
                  class="m-0 rounded-drop">
                  <template v-slot:button-content >
                    {{ statusLabel[question.status] }}
                    <i class="mdi mdi-chevron-down"></i>
                  </template>
                  <b-dropdown-item-button @click="toggleStatus(question.id, 0)">Pendente</b-dropdown-item-button>
                  <b-dropdown-item-button @click="toggleStatus(question.id, 1)">Aprovar</b-dropdown-item-button>
                  <b-dropdown-item-button @click="toggleStatus(question.id, 2)">Rejeitar</b-dropdown-item-button>
                </b-dropdown>
              </td>
              <td>{{ $moment(question.created_at).format('DD/MM/YY HH:mm') }}</td>
              <td>
                <b-button size="sm" variant="danger" @click="deleteQuestion(question.id)">
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row mt-4" v-show="publicQuestions.length > 0">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal de Configurações -->
    <b-modal
      id="modal-settings"
      ref="modal-settings"
      title="Configurações de Perguntas Públicas"
      title-class="font-18"
      size="md"
      :no-close-on-backdrop="true"
    >
      <b-form>
        <b-form-group label="Moderação" description="Escolha se as perguntas precisam de aprovação antes de aparecerem">
          <b-form-radio-group v-model="settings.public_questions_moderation">
            <b-form-radio :value="0">Imediato (sem moderação)</b-form-radio>
            <b-form-radio :value="1">Pré-aprovação (moderador aprova)</b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group label="Limite de perguntas por usuário" description="0 = ilimitado">
          <b-form-input
            type="number"
            v-model="settings.public_questions_limit_per_user"
            min="0"
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeSettingsModal()">Cancelar</b-button>
        <b-button variant="primary" @click="saveSettings()">Salvar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import roomService from '@/pages/rooms/services'

export default {
  name: 'public-questions',
  data () {
    return {
      settings: {
        public_questions_moderation: 1,
        public_questions_limit_per_user: 0
      },
      filter: {
        status: ''
      },
      statusOptions: [
        { value: '', text: 'Todos' },
        { value: 0, text: 'Pendentes' },
        { value: 1, text: 'Aprovados' },
        { value: 2, text: 'Rejeitados' }
      ],
      statusLabel: {
        0: 'Pendente',
        1: 'Aprovado',
        2: 'Rejeitado'
      },
      currentPage: 1,
      perPage: 20
    }
  },
  mounted () {
    this.loadSettings()
    this.updateList()
  },
  activated () {
    // Chamado quando o componente é ativado (keep-alive)
    this.updateList()
  },
  computed: {
    ...mapState('publicQuestion', ['publicQuestions', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('publicQuestion', {
      fetchData: 'getList',
      changeStatus: 'updateStatus',
      deleteItem: 'deletePublicQuestion'
    }),
    getStatusVariant (status) {
      if (status === 0) return 'warning'
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'secondary'
    },
    openSettingsModal () {
      this.$refs['modal-settings'].show()
    },
    closeSettingsModal () {
      this.$refs['modal-settings'].hide()
    },
    loadSettings () {
      roomService.roomSettings(this.$route.params.id)
        .then((response) => {
          if (response.data && response.data.data) {
            const roomSettings = response.data.data
            this.settings.public_questions_moderation = roomSettings.public_questions_moderation || 1
            this.settings.public_questions_limit_per_user = roomSettings.public_questions_limit_per_user || 0
          }
        })
        .catch((err) => {
          console.error('Erro ao carregar configurações:', err)
        })
    },
    saveSettings () {
      const payload = {
        id: this.$route.params.id,
        public_questions_moderation: this.settings.public_questions_moderation,
        public_questions_limit_per_user: this.settings.public_questions_limit_per_user
      }

      roomService.toogleSetting(payload)
        .then(() => {
          successMessage('Configurações salvas com sucesso!', 2500)
          this.closeSettingsModal()
        })
        .catch((error) => {
          errorMessage('Erro ao salvar configurações: ' + error.message)
        })
    },
    deleteQuestion (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.deleteItem({ room_id: this.$route.params.id, id: id }).then((res) => {
              successMessage('Sucesso: Pergunta excluída com sucesso.', 2500)
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
            this.updateList()
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    async toggleStatus (id, status) {
      try {
        await this.changeStatus({ room_id: this.$route.params.id, id: id, status: status })
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    updateList () {
      let loader = this.$loading.show()
      const params = {
        room_id: this.$route.params.id,
        limit: this.perPage,
        include: 'user',
        page: this.currentPage
      }

      // Adiciona status apenas se for diferente de vazio
      if (this.filter.status !== '') {
        params.status = this.filter.status
      }

      this.fetchData(params).then(() => {
        loader.hide()
      }).catch((err) => {
        loader.hide()
        errorMessage('Erro ao carregar perguntas: ' + err.message)
      })
    }
  },
  watch: {
    '$route.params.id': function (newId, oldId) {
      if (newId !== oldId) {
        this.loadSettings()
        this.updateList()
      }
    }
  }
}
</script>

<style scoped>
.rounded-drop .dropdown-toggle { border-radius: 1rem !important}
.swal2-popup {
  font-size: 11px !important;
}
</style>
